import { createSlice } from '@reduxjs/toolkit';
import portfolioProvider from 'data-access/portfolio-provider';
// import { message } from 'antd';
import recommendProvider from 'data-access/recommend-provider';
import roomProvider from 'data-access/room-provider';
import tickerProvider from 'data-access/ticker-provider';
import entriesProvider from 'data-access/entries-provider';
import { TYPE_VOLUME_SORT } from './configs';
// import { CURRENT_PAGE, PAGE_SIZE } from './configs';
// import uploadProvider from "@data-access/upload-provider";

const initialState = {
  roomList: [],
  listTicker: [],

  // Watchlist
  watchList: [],

  // Recommend
  roomIdSelected: null,
  typeVolumeSort: TYPE_VOLUME_SORT.GRETTER_THAN_ZERO,
  isTableRecommendLoading: false,
  entryList: [],
  recommendList: [],
  recommendHistoryList: []
};

export const riskManagementSlice = createSlice({
  name: 'riskManagement',
  initialState,
  reducers: {
    updateData: (state, action) => {
      const data = action.payload || {};
      const keys = Object.keys(data);
      keys.forEach((key) => {
        state[key] = data[key];
      });
    },
    updateRecommendHistoryList: (state, action) => {
      state.recommendHistoryList = action.payload;
    },
    updateListTicker: (state, action) => {
      state.listTicker = action.payload;
    },
    updateWatchList: (state, action) => {
      state.watchList = action.payload;
    },
    updateRecommendList: (state, action) => {
      state.recommendList = action.payload;
    },
    updateEntryList: (state, action) => {
      state.entryList = action.payload;
    }
  }
});

export const {
  updateData,
  updateListTicker,
  updateWatchList,
  updateRecommendList,
  updateRecommendHistoryList,
  updateEntryList
} = riskManagementSlice.actions;

export const getListTicker = () => {
  return async (dispatch) => {
    try {
      const res = await tickerProvider.getTickers();
      const { companyList } = res;
      dispatch(updateListTicker(companyList || []));
    } catch (err) {
      console.error(err);
    }
  };
};

export const getEntries = (type) => {
  return async (dispatch) => {
    try {
      const res = await entriesProvider.getEntries(type);

      dispatch(updateEntryList(res));
    } catch (err) {
      console.error(err);
    }
  };
};

export const validateRecommendTicker = (ticker) => {
  return async () => {
    try {
      await recommendProvider.validateWatchlist(ticker);
    } catch (err) {
      console.error(err);
    }
  };
};

export const getRecommendHistory = (transactionId) => {
  return async (dispatch) => {
    try {
      const res = await recommendProvider.getRecommendHistory(transactionId);

      dispatch(updateRecommendHistoryList(res));
    } catch (err) {
      console.error(err);
    }
  };
};

export const recommendWatchlist = (data) => {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      await recommendProvider.recommendWatchlist(data);

      dispatch(getWatchList());

      return;
    } catch (err) {
      throw err;
    }
  };
};

export const getWatchList = () => {
  return async (dispatch) => {
    try {
      const res = await recommendProvider.getWatchlist(1);

      dispatch(updateWatchList(res));
    } catch (err) {
      console.error(err);
    }
  };
};

export const getRooms = () => {
  return async (dispatch) => {
    try {
      const res = await roomProvider.getRooms();
      dispatch(
        updateData({
          roomList: res
        })
      );
    } catch (err) {
      console.error(err);
    }
  };
};

export const getRecommendList = () => {
  return async (dispatch) => {
    dispatch(
      updateData({
        isTableRecommendLoading: true
      })
    );

    try {
      const res = await portfolioProvider.getPortfolio();

      dispatch(updateRecommendList(res));
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(
        updateData({
          isTableRecommendLoading: false
        })
      );
    }
  };
};

export const createRecommand = (body) => {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      await recommendProvider.createRecommend(body);

      dispatch(getWatchList());

      return;
    } catch (err) {
      throw err;
    }
  };
};

export const updateRecommand = (body) => {
  return async () => {
    // eslint-disable-next-line no-useless-catch
    try {
      await recommendProvider.updateRecommend(body);

      return;
      // const msgText = body.isWatchlist
      //   ? `Chỉnh sửa mã ${body.ticker} trong watchlist thành công!`
      //   : `Chỉnh sửa khuyến nghị mã ${body.ticker} thành công!`;

      // message.success(msgText);
    } catch (err) {
      throw err;
    }
  };
};

export const selectListTicker = (state) => state.riskManagement.listTicker;
export const selectRecommendHistoryList = (state) => state.riskManagement.recommendHistoryList;
export const selectRoomList = (state) => state.riskManagement.roomList;
export const selectWatchList = (state) => state.riskManagement.watchList;
export const selectRecommendList = (state) => state.riskManagement.recommendList;
export const selectEntryList = (state) => state.riskManagement.entryList;
export const selectRoomIdSelected = (state) => state.riskManagement.roomIdSelected;
export const selectTypeVolumeSort = (state) => state.riskManagement.typeVolumeSort;
export const selectIsTableRecommendLoading = (state) =>
  state.riskManagement.isTableRecommendLoading;

export default riskManagementSlice.reducer;
